import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { activitiesQueryOptions } from '@/core/components/sites/site/activities-and-products/activitiesQueryOptions'
import { ratesQueryOptions } from '@/core/components/sites/site/rates-and-packages/rates/ratesQueryOptions'
import { getConnections } from '@/core/components/sites/site/site-customization/manage-site/advanced-tab/connectivityQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/create/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const rates = queryClient.ensureQueryData(
      ratesQueryOptions(siteId, auth.token!)
    )
    const activities = queryClient.ensureQueryData(
      activitiesQueryOptions(siteId, auth.token!)
    )
    const connections = queryClient.ensureQueryData(
      getConnections(siteId, auth.token!)
    )

    return {
      rates,
      activities,
      connections,
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
